module.exports = __webpack_public_path__ + "img/number06.bc6fb22b.svg";